import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api';

/**
 * Q-02: attendee screens must feel immediate on mobile data at a busy venue, so cached
 * data is shown while it revalidates rather than blanking the screen on every focus.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 30 * 60_000,
      // A dropped connection in a ballroom is worth trying again; a session that is not in the
      // published program will not be there on the third attempt either, and retrying it only
      // makes the attendee watch a spinner before reading the answer.
      retry: (failureCount, error) =>
        error instanceof ApiError && error.status >= 400 && error.status < 500
          ? false
          : failureCount < 2,
      refetchOnWindowFocus: false,
    },
  },
});
